import { render, staticRenderFns } from "./DomainsListToolbar.vue?vue&type=template&id=554eb012"
import script from "./DomainsListToolbar.vue?vue&type=script&lang=ts"
export * from "./DomainsListToolbar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports